import React from "react";
import Routes from "./routes/appRoutes";
import JWTProvider from './contexts/jwtContext';  
import 'antd/dist/reset.css';
import WpStatusPoller from './components/wpStatusPoller';

const App = () => {
  return (
    <JWTProvider>
      <WpStatusPoller />
      <Routes />
    </JWTProvider>
  );
};

export default App;